import { render, staticRenderFns } from "./pcquerys.vue?vue&type=template&id=61b37c3e"
import script from "./pcquerys.vue?vue&type=script&lang=js"
export * from "./pcquerys.vue?vue&type=script&lang=js"
import style0 from "./pcquerys.vue?vue&type=style&index=0&id=61b37c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports